<template>
    <ion-toolbar>
        <ion-buttons slot="start"
            v-if="$store.state.pages.auth.back.length || ['profile_software_experience', 'profile_job_seeker_software_experience', 'locum_jobseeker_software_experience'].includes(routeName)">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end"
            v-if="!['profile_software_experience', 'profile_job_seeker_software_experience'].includes(routeName)">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Pharmacy Management Software </h1>
                    <span>{{ softwareExperienceCustomFields.length > 0 ? softwareExperienceCustomFields[0].label :
                        '' }}</span>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :label-position="'top'" @submit.prevent="goNext('userForm')">

                <el-form-item prop="schedule" class="job_filters_form_checkbox">
                    <template v-if="softwareExperienceCustomFields.length > 0">
                        <template v-for="(field, index) in softwareExperienceCustomFields" :key="index">
                            <template v-if="field.fieldType === 'MultiSelectcheckbox'">
                                <el-checkbox-group v-model="form.selectedValues">
                                    <div v-for="(value, i) in field.values" :key="i">
                                        <el-checkbox :label="value.label"
                                            @change="handleCheckboxChange(value, index)">{{
                                                value.label }}</el-checkbox>
                                        <el-input v-if="isDynamicSelected(value)" v-model="form[value.label]"
                                            :placeholder="`Enter ${value.label}`" @input="sanitizeInput(value.label)"></el-input>

                                    </div>
                                </el-checkbox-group>
                            </template>
                            <el-form-item-error v-if="v$.selectedValues.$error">{{ v$.selectedValues.$errors[0].$message
                                }}</el-form-item-error>
                        </template>
                    </template>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button :disabled="isSubmitDisabled" class="submit" type="blue" @click="goNext('userForm')">
                       {{ routeName == 'profile_software_experience' || routeName == 'profile_job_seeker_software_experience' ? 'Save' : 'Continue'}}
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
            </div>
        </div>
    </div>
</template>


<script>
import {
    onMounted,
    inject,
    onBeforeMount,
    ref,
    reactive,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
// import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon,
    },
    directives: {
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const $route = useRoute()
        const routeName = $route.name;
        const softwareExperienceCustomFields = ref([]);
        console.log("🚀 ~ setup ~ customFields:", softwareExperienceCustomFields)
        const userData = $store.getters.GET_USER_DATA;

        const form = reactive({
            selectedValues: ref(userData.customFields?.softwareExperience?.map(item => item.value) || []),
            Others: ref(userData.customFields?.softwareExperience?.find(item => item.value === 'Others')?.otherValue || null)
        });

        const rules = computed(() => {
            return {
                selectedValues: { required: helpers.withMessage('Please select software', required) },
            };
        });
        const v$ = useVuelidate(rules, form);

        const goBack = async() => {

            if (routeName == "profile_software_experience") {
                $router.push({
                    name: "profile_edit"
                })
            } else if (routeName == "profile_job_seeker_software_experience") {
                $router.push({
                    name: "basic_profile_job_seeker"
                })
            } else if (routeName == "locum_jobseeker_software_experience") {
                $router.push({
                    name: "additional_onboard_locum_job_seeker"
                })
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });
            }
        };

        const isDynamicSelected = (value) => {
            return (
                form.selectedValues.includes(value.label) && value.showTextbox === true
            );
        };

        const goNext = async () => {
            // const result = await v$.value.$validate();

            // if (!result) {
            //     alert('The form has errors');
            //     return;
            // } else {

            if (form.selectedValues.length === 0) {
                if (routeName == "profile_software_experience") {
                    $router.push({
                        name: "profile_edit"
                    })
                } else if (routeName == "profile_job_seeker_software_experience") {
                    $router.push({
                        name: "basic_profile_job_seeker"
                    })
                } else if (routeName == "locum_jobseeker_software_experience") {
                    $router.push({
                        name: "locum_jobseeker_pharmacist_certifications"
                    })
                }else if (routeName == "auth_internal_software_experience") {
                    $router.push({
                        name: "auth_internal_pharmacist_certifications"
                    })
                }  else {
                    $router.push({
                        name: "auth_pharmacist_certifications"
                    })
                }
            } else {
                const values = [];

                for (const selectedValue of form.selectedValues) {
                    const otherValue = form[selectedValue] ? form[selectedValue] : "";
                    values.push({ value: selectedValue, other_value: otherValue });
                }

                const payload = [
                    {
                        key: 'software_experience',
                        values: values
                    }
                ]

                try {
                    await $store.dispatch("SAVE_USER_SOFTWARE_EXPERIENCE_DATA", payload);

                    if (routeName == "profile_software_experience") {
                        $router.push({
                            name: "profile_edit"
                        })
                    } else if (routeName == "profile_job_seeker_software_experience") {
                        $router.push({
                            name: "basic_profile_job_seeker"
                        })
                    }else if (routeName == "locum_jobseeker_software_experience") {
                        $router.push({
                            name: "locum_jobseeker_pharmacist_certifications"
                        })
                    }else if (routeName == "auth_internal_software_experience") {
                        $router.push({
                            name: "auth_internal_pharmacist_certifications"
                        })
                    } else {
                        $router.push({
                            name: "auth_pharmacist_certifications"
                        })
                    }
                } catch (error) {
                    console.log(error);
                }
            }

            // }
        };

        const skip = () => {
            (async () => {
                // try {
                //     await ElMessageBox.confirm(
                //         ``,
                //         "Do you want to skip? You will be unverified",
                //         {
                //             distinguishCancelAndClose: true,
                //             showConfirmButton: true,
                //             confirmButtonText: "Skip",
                //             cancelButtonText: "Cancel",
                //             confirmButtonClass: "el-button--green",
                //             cancelButtonClass: "el-button--grey",
                //             showClose: true,
                //         }
                //     );
                // } catch {
                //     return;
                // }
                try {
                if(routeName == 'locum_jobseeker_software_experience') {
                    $store.dispatch('addAuthPageBack', 'locum_jobseeker_software_experience');
                    $router.push({
                        name: 'locum_jobseeker_pharmacist_certifications',
                    })

                }else if(routeName == 'auth_internal_software_experience'){
                    $store.dispatch('addAuthPageBack', 'locum_jobseeker_software_experience');
                    $router.push({
                        name: 'auth_internal_pharmacist_certifications',
                    })
                }else{
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_pharmacist_certifications',
                    })
                }
                   
                } catch (error) {
                    console.log(error);
                }
            })();

        }

        const validateField = (fieldName) => {
            console.log("🚀 ~ validateField ~ fieldName:", fieldName)
            // Trigger validation for the specified field
            v$.value[fieldName].$touch();
        };

        onMounted(() => {
            setPageClassGlobal('global_auth_pharmacy_experience_page');

        });

        onBeforeMount(async () => {
            try {
                const response = await $store.dispatch("GET_CUSTOM_FIELDS",);
                console.log("🚀 ~ onBeforeMount ~ check:", response)
                softwareExperienceCustomFields.value = response.data.softwareExperience;
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });

        const handleCheckboxChange = (value, index) => {
            console.log("🚀 ~ handleCheckboxChange ~ index:", index)
            console.log("🚀 ~ handleCheckboxChange ~ value:", value.label)
            // If the "Speciality" checkbox is checked, show the input field

            if (value.showTextbox && form.selectedValues.includes(value.label)) {
                const ruleKey = value.label;
                rules.value[ruleKey] = { required };

                // Add the otherInputValue[index] field to the form
                const fieldValue = "";
                form[ruleKey] = ref(fieldValue);

                // Touch the field to trigger validation
                v$.value.$touch(ruleKey);
            } else {
                const ruleKey = value.label;
                delete rules.value[ruleKey];
                delete form[ruleKey];
            }
        };


        const isSubmitDisabled = computed(() => {
            // Check if there are validation errors
            const hasValidationErrors = v$.value.$error;

            // Check if any form field is incomplete
            const isFormIncomplete = Object.keys(form).some((key) => {
                const value = form[key];

                // For dynamic fields (e.g., "Other"), only validate if the corresponding option is selected
                if (key === "Others" && !form.selectedValues.includes("Others")) {
                    return false; // Skip validation for "Others" if not selected
                }

                // Validate text fields (allow only non-empty strings)
                if (typeof value === "string") {
                    return value.trim() === ""; // Invalid if empty or whitespace
                }

                // Validate array fields (e.g., multiselects)
                if (Array.isArray(value)) {
                    return value.length === 0; // Invalid if no items are selected
                }

                // General null/undefined check
                return value == null;
            });

            return hasValidationErrors || isFormIncomplete;
        });
        // const isSubmitDisabled = computed(() => {
        //     return false;
        // });

        const sanitizeInput = (label) => {
        // Prevent starting with space and sanitize input
        // Check if the initial character is a space
        if (form[label]?.startsWith(' ')) {
            // If it starts with a space, remove it
            form[label] = form[label].trimStart();
        }
        };


        return {
            goBack,
            goNext,
            handleCheckboxChange,
            isDynamicSelected,
            softwareExperienceCustomFields,
            form,
            rules,
            v$,
            validateField,
            isSubmitDisabled,
            skip,
            routeName,
            sanitizeInput
        }
    },
}
</script>